import { Component, Input, Output, EventEmitter, SimpleChange, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import * as _ from "lodash";
import RecipeNode from '../../subproducts/subproducts-tree/recipe-node';

@Component({
  selector: 'product-type-grid-grouped',
  templateUrl: './product-type-grid-grouped.component.html',
  styleUrls: ['./product-type-grid-grouped.component.scss']
})
export class ProductTypeGridGruopedComponent {

  @Input() tree: any[] = [];

  nodes: RecipeNode[] = [];

  @ViewChild("download") downloadLink: ElementRef;

  constructor(private renderer: Renderer2) { }

  ngOnChanges(sc: SimpleChange) {
    if (_.has(sc, 'tree.currentValue') && sc['tree'].currentValue.length > 0) {
      const tree = sc['tree'].currentValue[0];
      let nodes = tree.getAllNodes();
      let grouped = _.groupBy(nodes, (n) => n.product?.PartNumber);
      this.nodes = _.map(grouped, (group) => {
        return {
          obj: _.first(group),
          quantity: _.sumBy(group, 'quantity'),
          availability: _.get(group, '[0].availability'),
          availabilityMeasure: _.get(group, '[0].availabilityMeasure'),
        }
      });
    }
  }

  downloadList() {
    const csv = this.nodes.map(node => this.nodeToCSV(node)).join("\n");
    this.renderer.setAttribute(this.downloadLink.nativeElement, "href",
      "data:text/plain;charset=utf-8," + csv);
  }

  nodeToCSV(node) {
    return [
      node.obj.product?.PartNumber,
      node.obj.name,
      node.quantity + ' ' + node.obj.product?.MeasurementUnit?.Code,
      node.availability + ' ' + node.availabilityMeasure,
      node.obj.product?.ProductType?.Name?.BG,
      node.obj.product?.CustomProperty_StoreForProdOrder?.Description?.BG,
    ].join(";");
  }
}
